import { Navigate, Outlet } from "react-router";
import { useEffect, useState } from "react";
import { axios } from "@/client/libs/axios";

export const AdminGuard = () => {
  const [hasAccess, setHasAccess] = useState<boolean | null>(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const checkAdminAccess = async () => {
      try {
        setIsLoading(true);

        // Make API call to verify admin access with server
        // The server will check if the current user is an admin based on their email
        const response = await axios.get("/admin/verify");

        if (response.status === 200) {
          setHasAccess(true);
        } else {
          setHasAccess(false);
        }
      } catch (error) {
        // If API call fails or returns error, deny access
        console.error("Admin access verification failed:", error);
        setHasAccess(false);
      } finally {
        setIsLoading(false);
      }
    };

    checkAdminAccess();
  }, []);

  // Show loading state while checking
  if (isLoading || hasAccess === null) {
    return (
      <div className="flex min-h-screen items-center justify-center">
        <div className="text-center">
          <div className="h-8 w-8 animate-spin rounded-full border-4 border-blue-500 border-t-transparent"></div>
          <p className="mt-2 text-gray-600">Verifying admin access...</p>
        </div>
      </div>
    );
  }

  // Redirect to home if no admin access
  if (!hasAccess) {
    return <Navigate replace to="/" />;
  }

  return <Outlet />;
};
